import {
  financialFetch,
  financialPost,
  financialPut,
  financialDelete,
} from "../../../Component/function/FinancialApi";

const ENDPOINT = "FinancialTransaction";

const buildQueryUrl = (params = {}) => {
  const cleaned = {};

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== "" &&
      value !== null &&
      value !== undefined
    ) {
      cleaned[key] = value;
    }
  });

  const query = new URLSearchParams(cleaned).toString();

  return query ? `${ENDPOINT}?${query}` : ENDPOINT;
};

const financialTransactionService = {
  getAll: async (params = {}) => {
    return await financialFetch(
      buildQueryUrl(params)
    );
  },

  getById: async (id) => {
    return await financialFetch(
      `${ENDPOINT}/${id}`
    );
  },

  create: async (payload) => {
    const response = await financialPost(
      ENDPOINT,
      payload
    );

    return response?.data;
  },

  update: async (id, payload) => {
    const response = await financialPut(
      `${ENDPOINT}/${id}`,
      payload
    );

    return response?.data;
  },

  remove: async (id) => {
    const response = await financialDelete(
      `${ENDPOINT}/${id}`
    );

    return response?.data;
  },
};

export default financialTransactionService;